module.exports = __webpack_public_path__ + "static/media/image5.0561c673.JPG";